<template>
<div>

<!-- <span v-for="pop in this.list_pop.items" :key="pop.seq"> 팝업 여러개일 수도
  <c메인공지 :ref="mainNotice_`pop.seq`" :item=this.list_pop.items />
</span> -->

<c메인공지 ref="mainNotice" />

	<div class="main_killer01" >
      <div class="killer_cont">
      <img src="/images/main/main_killer03.jpg" class="main_banner_img">
        <!--
        <div class="main_killer_txt">

          <h1> 간편! 간단! 간소! </h1>

            <h2 style="color: white">온라인 경유 사이트 오픈,</h2>
            <h2 style="color: white">2020년 1월 2일부터</h2>
            <h2 style="color: white">경유증표 구입이 편리해집니다.</h2>
        </div> -->
        <div class="main_sch">
          <div class="input_wrap">
            <div class="sch_box">
              <input class="no left" type="text" v-model="search.rcptno1" ref="rcptno1" v-mask="'#####'"  v-tooltip.top="'증표번호 앞 5자리를 입력해 주세요'" placeholder="증표번호1" @keyup.enter="doSearch()" v-on:keyup="$event.target.value.length >= 5 && $event.target.nextElementSibling.focus()" />
              <span>-</span>
              <input class="no right" type="text" v-model="search.rcptno2" ref="rcptno2" v-mask="'######'" v-tooltip.top="'증표번호 뒤 6자리를 입력해 주세요'" placeholder="증표번호2" @keyup.enter="doSearch()" v-on:keyup="$event.target.value.length >= 6 && $event.target.nextElementSibling.focus()" />
              <!-- <input class="name" type="text" v-model="search.membno" ref="membno" v-mask="'#####'" v-tooltip.top="'개인 회원일 경우 (00000) 법무법인일 경우 법인 등록번호(00000) 5자리를 입력해 주세요'" placeholder="회원번호"  v-on:keyup="$event.target.value.length >= 5 && $event.target.nextElementSibling.focus()" /> -->
              <input class="name" type="text" v-model="search.client" ref="client" maxlength="20" v-tooltip.buttom="'위임인을 2글자 이상 입력해 주세요'" placeholder="위임인" @keyup.enter="doSearch" />

            </div><!-- //sch_box -->
            <div class="btn_no btn" @click="doSearch()"><img src="/images/common/icon_search_w_b.png"></div>
          </div><!-- //input_wrap -->

          <div class="btn xl btn_qr " @click="qrcodeScan">QR코드<em class="pc">검색 (모바일)</em></div>
          <span class="btn white02 btn_govia" @click="$router.push('/apply/return_req_req')">수임사건 건수 및 수임액 신고</span>
        </div> <!-- //main_sch -->

      </div> <!-- //killer_cont -->
	</div><!-- // main_killer01 -->
  <div class="main_icon_wrap">
        <ul>
          <li><a target="_blank" href="https://www.seoulbar.or.kr/site/mypage/MyPageWalHoeiBiArrEars.do"><dt class="bg_round"><img src="/images/main/icon_01.png"></dt></a> <p>월회비</p> </li>
          <li><a target="_blank" href="https://www.seoulbar.or.kr/site/mypage/MyPagePointActList.do"><dt class="bg_round"><img src="/images/main/icon_04.png"></dt></a><p>회원포인트</p></li>
          <li><a target="_blank" href="https://www.seoulbar.or.kr/site/online/OnlineEducationCompleteHistory.do"><dt class="bg_round"><img src="/images/main/icon_03.png"></dt></a><p>연수교육</p>  </li>
          <li><a target="_blank" href="https://www.seoulbar.or.kr/site/online/OnlineReSignApplication.do"><dt class="bg_round"><img src="/images/main/icon_02.png"></dt></a> <p>공익활동</p> </li>
          <li><a target="_blank" href="https://www.seoulbar.or.kr/EgovPageLink.do?link=/site/introduction/IntroductionLawyersCard"><dt class="bg_round"><img src="/images/main/icon_05.png"></dt></a> <p>Lawyer's Card</p> </li>
          <li><a target="_blank" href="http://news.seoulbar.or.kr/"><dt class="bg_round"><img src="/images/main/icon_06.png"></dt></a> <p>회보</p> </li>
        </ul>
    </div>	<!--// main_icon_wrap -->

	<div class="container main">
		<section>
			<!-- 공지사항 -->
			<article >
        <h1>공지사항 <font @click="qrcodeScan">NOTICE</font><span style="cursor:pointer" @click="goNotiPage(null)">+</span></h1>
				<div class="box h_shadow">
					<div class="cont">
						<ul>
              <li v-for="(item, i) in list_noti.items.slice(0,6)" :key="i">
                <span @click="goNotiPage(item)">{{ item.titl }}</span>
              </li>
						</ul>
					</div>
				</div>
			</article>

			<!-- 자주 묻는 경유 FAQ -->
			<article >
				<h1>자주 묻는 질문 <font>FAQ</font><span style="cursor:pointer" @click="goFaqPage(null)">+</span></h1>
				<div class="box h_shadow faq">
					<div class="cont">
						<ul>
              <li v-for="(item, i) in list_faq.items.slice(0, 6)" :key="i">
                <span @click="goFaqPage(item)">{{ item.titl }}</span>
              </li>
						</ul>
					</div>
				</div>
			</article>

			<!-- 수임사건 경유업무 홈페이지 -->
			<article class="icons">
				<h1>바로가기 <font>SHORTCUT</font></h1>
				<div class="box h_shadow">
						<dl class="d01" @click="$router.push('/buy/buy_form')">
							<dt>증표 구입</dt>
							<dd>전자증표 온라인 구입</dd>
              <img src="/images/main/icon_mr_won.png">
						</dl>
						<dl class="d02" @click="$router.push('/use/use_via')">
							<dt>증표 사용·등록</dt>
							<dd>경유증표 사용내역 등록</dd>
              <img src="/images/main/icon_mr_ham.png">
						</dl>
						<dl class="d03" @click="$router.push('/use/edit_via')">
							<dt>증표 조회·수정</dt>
							<dd>경유증표 사용내역 조회·수정</dd>
              <img src="/images/main/icon_mr_pc.png">
						</dl>
						<dl class="d04" @click="$router.push('/apply/return_req_req')">
							<dt>수임사건 신고</dt>
							<dd>수임사건 건수 및 수임액 신고</dd>
              <img src="/images/main/icon_mr_check.png">
						</dl>
				</div>
			</article>

		</section>

	</div>

  <!-- 여기 여백주기가 왜이리 어렵지 ㅠㅠ ?? p br div 다 안먹는다..  -->
  <section class="law_warp" style="background: none; margin: 0; padding: 0; height: 30px;">
    <div class="container" style="background: none; margin: 0; padding: 0;">
      &nbsp;
    </div>
  </section>
  <!-- <div style="height: 200px; margin: 200px; padding 200px; padding: 1px solid red">&nbsp;</div> -->

  <!-- // container -->
<!--   <section class="law_warp ">
      <div class="container ">
        <h4>수임사건경유</h4>

				<p>

					회원은 <font class="org01">변호사법 제28조의 2, 제29조 및 회칙 제12조</font>에 따라 소송위임장 또는 변호인선임서를 법원, 검찰, 기타 공공기관등에 제출하는 경우 반드시 사전에 본회를 경유하여야하고, 매년 1월말까지
					전년도에 처리한 수임사건의 건수 및 수임액을 본회에 신고하여야 합니다.
				</p>
				<p>
					본회와 법원행정처는 <font class="org01">과세자료의 제출 및 관리에 관한 법률</font>에 따라 회원의 수임사건 경유내용을 <font class="blue01">매년 1회 세무당국에 통보</font>하고 있으므로 회원은 자료의 불일치로 불이익을 받지 않도록 수임사건내용을
					누락없이 경유증표사용일로부터 일주일이내에 본회 경유업무프로그램을 통하여 입력하여야 합니다. 그러지 않으면 입력된 경유증표사용내역은 입력 수정할 수 없습니다.
				</p>
				<p>
					공직퇴임변호사(사법연수생과 병역의무 이행 공익법무관 등 제외)는 변호사법 제89조의 4 및 동법 시행령 제20조의 11에 따라 공직퇴직일로부터 2년 동안 수임한 사건에 관한 수임자료 및 처리결과를
					매년 2회(1월말, 7월말) 본회에 서면으로 제출하여야 합니다.
				</p>
				<p>
					본회는 공직퇴임변호사로부터 제출받은 자료와 <font class="org01">변호사법 제89조의 5 및 동법 시행령 제20조의 12</font>에 따라 선정한 특정변호사(법무법인의 담당변호사 포함)의 성명과 사건목록을 매녀 2회(1월말, 7월말)
					법조윤리협의회에 통보합니다.
				</p>
      </div>
  </section>  -->
  <!-- //law_warp -->
</div> <!-- //block -->
</template>

<style>
@import '../../assets/css/main.css';
</style>

<!-- Global site tag (gtag.js) - Google Analytics -->
<script async src="https://www.googletagmanager.com/gtag/js?id=G-FMSMVTV8DN"></script>
<script>
  window.dataLayer = window.dataLayer || [];
  function gtag(){dataLayer.push(arguments);}
  gtag('js', new Date());

  gtag('config', 'G-FMSMVTV8DN');
</script>

<script>

let ui;
export default {
  components: {
    "c메인공지"    : require('./c메인공지.vue').default, // mainNotice
  },
  data () {
    return {
      search: {
        rcptno1: '',
        rcptno2: '',
        membno: '',
        client: '',
      },
      list_noti : { items: [{titl : '', answ:''}] }, // 공지사항
      list_faq  : { items: [{titl : '', answ:''}] }, // [홈페이지 이용방법] = FAQ 목록
      list_pop  : {},
    }
  },
  created() {
    ui = this.$ui
  },
   mounted() {
     /*
	    $('.mbtn').click( function() {
	        var toggleWidth = $(".main_quickicon").width() == 520 ? "600px" : "520px";
	        $('.main_quickicon').animate({ width: toggleWidth }, 400);
	        $('.mbtn').toggleClass('rotate');
      }); */
      this.getData()
      this.getPopup()

  },
  methods: {
    doSearch() {
      if (this.search.rcptno1.length != 5) return ui.alert("증표번호 앞자리는 5자리 숫자로 입력해 주세요.").then(v=>this.$refs.rcptno1.focus())
      if (this.search.rcptno2.length != 6) return ui.alert("증표번호 뒷자리는 6자리 숫자로 입력해 주세요.").then(v=>this.$refs.rcptno2.focus())
      // if (this.search.membno.length  != 5) return ui.alert("회원번호 5자리 숫자로 입력해 주세요.").then(v=>this.$refs.membno.focus())
      if (this.search.client.length  <  2) return ui.alert("위임인은 2글자 이상 입력해 주세요").then(v=>this.$refs.client.focus())
      ui.httpGet("/public/proc/N_VIAINFO_SEARCH_MAIN",
        {
          ...this.search,
          mode : "CHECK",
        }, ret => {
          const {msg, status, field} = ret.data.rs1[0];
          if (status != '0') {
            return ui.alert(msg)
              .then(v=>{
                if (field)
                  this.$refs[field].select()
              })
          }
          if (status == '0') {
            // 증표정보 있음.
            this.$router.push({path: '/viainfo/detail', query: { ...this.search }})
          }
        }
      )

    },
    qrcodeScan() {
      try {
        location.href="seoulbar:///run_qrcode_scan"
      } catch(e) {
        alert('서울지방변호사회 앱을 사용해 주세요') // TODO CHECK 구현예정
      }

    },
    getData() {

      ui.httpGet("/public/proc/N_ANN_SEL_LIST_ADM", {
          iv_mode           : 'MAIN',
          iv_pgsize         : 7,
          iv_page           : 1,
          iv_search_text    : '',
          iv_search_type    : '',
          iv_permiss        : 'M10300',
        },ret => this.list_noti.items = _.get(ret, "data.rs2", []))

      ui.httpGet("/public/proc/N_FAQ_SEL_LIST", {
          iv_mode           : 'FRONT',
          strfromday        : '',
          strtoday          : '',
          iv_pgsize         : 7,
          iv_page           : 1,
          iv_search_text    : '',
          iv_search_type    : 'titl_cont',
          iv_search_faqcate : 'ALL',
        },ret => this.list_faq.items = _.get(ret, "data.rs2", []))

    },
    getPopup(){
      ui.httpGet("/public/proc/N_DIS_SEL_LIST", {
          iv_pgsize         : 1,
          iv_page           : 1,
          iv_menu           : 'pront', // pront, emp 구분
          iv_search_gubun   : 'pop', // 전시구분 팝업
          iv_search_kind    : 'Y',   // 사용여부
        },ret => {

          // console.log("--------------");
          // console.log(_.get(ret, "data.rs1", []));

          this.list_pop.items = _.get(ret, "data.rs2", [])

          // 팝업을 포문을 돌려 띄우(고 싶었음)
          // this.list_pop.items.forEach(e => {
          //   console.log(e)
          //   this.$refs.mainNotice.show(e)
          // });
          console.log(this.list_pop.items);

          let popupitem = this.list_pop.items
          if(popupitem.length > 0){ // 팝업이 있는 경우에만
          console.log("655555555");
          console.log(popupitem);

            this.$cookie.get('todayyn_' + popupitem[0].seq) != '1' ? this.$refs.mainNotice.show(popupitem[0]) : ''
          }


        })
    },
    goFaqPage(item) {
      if (item == null) {
        this.$router.push({ path: '/board/faq' })
      } else {
        this.$router.push({ path: '/board/faq', query: { seq: item.seq } })
      }
    },
    goNotiPage(item) {
      if (item == null) {
        this.$router.push({ path: '/board/board_list' })
      } else {
        this.$router.push({ path: '/board/board_view', query: { seq: item.seq }})
      }
    },
  },
}


/*
				 $(function() {
					//퀵 축소시
					$('.doToThin').click(function() {
						$('.doToThin').toggle();
						$('.doToWide').toggle();

						<c:if test="${ not isMobile}">
							$('.wfull_pc').css('width', '260px');
						</c:if>
						<c:if test="${ isMobile}">
							$('.wfull_mobile').css('height', '220px'); //~10개이하는 220px, 10~15개, 16~20개 로 줄이 늘어나는 경우 +90px 계산하여 더함
						</c:if>
						$('.main_quickicon').css('background-color', 'rgba( 22, 46, 78, 0.85 )');

						// 변호사 로그인 디자인
						<c:if test="${ loginGubun eq 'L' }">
							$('.main_quickicon').css('background-color', 'rgba( 50, 41, 22, 0.85 )');
						</c:if>
					});

					//퀵 확장시
					$('.doToWide').click(function() {
						$('.doToThin').toggle();
						$('.doToWide').toggle();

						<c:if test="${ not isMobile}">
							$('.wfull_pc').css('max-width', '440px'); // width : ~10개이하는 260px, 10~15개, 16~20개 로 줄이 늘어나는 경우 +90px 계산하여 더함
							$('.wfull_pc').css('width', '440px'); // width : ~10개이하는 260px, 10~15개, 16~20개 로 줄이 늘어나는 경우 +90px 계산하여 더함
						</c:if>
						<c:if test="${ isMobile}">
							$('.wfull_mobile').css('height', '402px'); //~10개이하는 220px, 10~15개, 16~20개 로 줄이 늘어나는 경우 +90px 계산하여 더함
						</c:if>

						$('.main_quickicon').css('background-color', 'rgba( 22, 46, 78, 0.95 )');
						//  변호사 로그인 디자인
						<c:if test="${ loginGubun eq 'L' }">
							$('.main_quickicon').css('background-color', 'rgba( 50, 41, 22, 0.95 )');
						</c:if>

					});

         });
*/

</script>
